import { render, staticRenderFns } from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=template&id=59c716a0&scoped=true&"
import script from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=script&lang=js&"
export * from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=style&index=0&id=59c716a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c716a0",
  null
  
)

export default component.exports